import React from "react"

import ProductAccordionItem from "./ProductAccordion/ProductAccordionItem"
import ProductAccordionList from "./ProductAccordion/ProductAccordionList"

const ProductDocsList = ({ title, children }) => (
  <ProductAccordionItem title={title}>
    <ProductAccordionList>{children}</ProductAccordionList>
  </ProductAccordionItem>
)

export default ProductDocsList
